module.exports = __webpack_public_path__ + "static/media/car-seat.8dcf343d.svg";